import { Component, EventEmitter, Input, Output } from "@angular/core";

import { MatDialogRef } from "@angular/material/dialog";

/**
 * This is a component intended to be used for dialogs that are not routed modals
 */
@Component({
  selector: "myqq-dialog-modal",
  exportAs: "dialog",
  templateUrl: "./dialog-modal.component.html",
  styleUrls: ["./dialog-modal.component.scss"],
})
export class DialogModalComponent<T = unknown> {
  constructor(readonly dialogRef: MatDialogRef<DialogModalComponent>) {}
  @Input() staticHeight = true;
  @Input() showHeaderDivider: boolean = false;
  @Output() modalClose: EventEmitter<T> = new EventEmitter<T>();

  closeModal($event?: T) {
    this.dialogRef.close();
    this.modalClose.next($event);
  }

  articleClick($event: MouseEvent) {
    $event.stopImmediatePropagation();
  }
}
